import { EditorRoutes, AuthRoutes, MainRoutes } from './MainRoutes';

// project import
// import AuthRoutes from './AuthRoutes';
import { useRoutes } from 'react-router-dom';

// ==============================|| ROUTING RENDER ||============================== //


export default function ThemeRoutes({ isAuthenticated }) {
  // Conditionally render routes based on isAuthenticated prop
  const routes = isAuthenticated !== null ? [MainRoutes, EditorRoutes] : [AuthRoutes];

  return useRoutes(routes);
}